import React, { useState, useEffect } from 'react'
import './Home.css'
import Footer from '../UIElements/Footer'
import HomeHomeNavigation from './HomeHomeNavigation'
import LoadingSpinner from '../UIElements/LoadingSpinner'
import ErrorModal from '../UIElements/ErrorModal'
import YouTube from 'react-youtube'
import Carousel from 'react-bootstrap/Carousel'
var getYouTubeID = require('get-youtube-id')

const Home = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [ids, setIds] = useState([])
	const [videoTitles, setVideoTitles] = useState([])
	const [videoCaptions, setVideoCaptions] = useState([])
	const [loadedVideos, setLoadedVideos] = useState([])
	const [loadedNews, setLoadedNews] = useState([])
	const [loadedCarouselPhotos, setLoadedCarouselPhotos] = useState([])
	//console.log('auth: ' + JSON.stringify(auth))

	//Get all videos designated for the Home Page
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/homePageVideos'
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedVideos(responseData.allHomePageVideos)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			//
			//
			setIsLoading(false)
		}

		sendRequest()
	}, [])

	let arrayOfTitles, arrayOfIds, arrayOfCaptions
	arrayOfTitles = []
	arrayOfIds = []
	arrayOfCaptions = []
	if (loadedVideos && !isLoading && ids.length === 0) {
		loadedVideos.forEach((video) => {
			arrayOfTitles.push(video.videoTitle)
			arrayOfIds.push(getYouTubeID(video.videoURL))
			arrayOfCaptions.push(video.videoCaption)
		})
	}

	if (arrayOfTitles.length > 0) {
		setVideoTitles(arrayOfTitles)
	}
	if (arrayOfIds.length > 0) {
		setIds(arrayOfIds)
	}
	if (arrayOfCaptions.length > 0) {
		setVideoCaptions(arrayOfCaptions)
	}
	//
	//
	//
	//Get all Carousel photos
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/carouselPhotos'
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedCarouselPhotos(responseData.allCarouselPhotos)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			//
			//
			setIsLoading(false)
		}
		sendRequest()
	}, [])
	//
	//
	loadedCarouselPhotos &&
		console.log('loadedCarouselPhotos: ' + JSON.stringify(loadedCarouselPhotos))
	//
	//
	//
	//
	//Get all News
	useEffect(() => {
		const sendRequest2 = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/news'
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedNews(responseData.allNews)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			//
			//
			setIsLoading(false)
		}

		sendRequest2()
	}, [])
	//
	//
	//
	//
	//
	//
	//
	const errorHandler = () => {
		setError(null)
	}
	//
	//
	return (
		<div style={{ overflowX: 'hidden' }}>
			<React.Fragment>
				<ErrorModal error={error} onClear={errorHandler} />
				{isLoading && <LoadingSpinner asOverlay />}
				{!isLoading && (
					<div>
						<header className='homeHeader' style={{ marginTop: '1rem' }}>
							<HomeHomeNavigation />
							<div className='text-light text-md-right text-center banner headingWriting'></div>
						</header>
						{/* <div className='section pt-5'>
							<div className=''>
								<div className='row'>
									<div className='col text-center'>
										<h1 className='text-sh-dark display-2'>News and Updates</h1>
									</div>
								</div>
								<div className='row'>
									<div className='col-lg-3 col-sm-6'></div>
									{!isLoading &&
										loadedNews &&
										loadedNews.map((news, key) => {
											return (
												<div>
													<h1 style={{ color: 'red' }}>{news.newsHeading}</h1>

													<p
														className='caption'
														style={{
															textAlign: 'center',
															color: 'black',
														}}
													>
														{news.newsSubheading}
													</p>
													<p
														className='caption'
														style={{
															textAlign: 'center',
															color: 'black',
														}}
													>
														{news.newsDate}
													</p>
													<h3
														className='content'
														style={{
															textAlign: 'center',
															color: 'black',
															marginBottom: '3rem',
															whiteSpace: 'pre-wrap',
														}}
													>
														{news.newsContent}
													</h3>
												</div>
											)
										})}
									<div className='col-lg-3 col-sm-6'></div>
								</div>
							</div>
						</div> */}
						{/* //
						//
						//
						//     CAROUSEL
						//
						//
						//
						// */}
						<div className='section pt-5'>
							<div className=''>
								<div className='row'>
									<div className='col text-center mb-3'>
										<h1
											className='display-2'
											style={{
												color: '#89292a',
											}}
										>
											Winning Trophies Since 2022...
										</h1>
									</div>
								</div>
								{/* //
								//
								// */}
								<div className='section'>
									<div className='row'>
										<div className='col-lg-3 col-sm-6'></div>
										{!isLoading && loadedCarouselPhotos && (
											<Carousel>
												{loadedCarouselPhotos.map((photo, key) => (
													<Carousel.Item interval={7000}>
														<img
															className='d-block carouselPhoto'
															src={`${process.env.REACT_APP_AWS_BUCKET}/${photo.photo}`}
															alt='Image One'
														/>
													</Carousel.Item>
												))}
											</Carousel>
										)}
										<div className='col-lg-3 col-sm-6'></div>
									</div>
								</div>
							</div>
						</div>
						{/* //
						//
						//
						//    END OF CAROUSEL
						//
						//
						//
						// */}
						<div className='section pt-5 videos'>
							<div className=''>
								<div className='row'>
									<div className='col text-center mb-0'>
										<h1 className='text-sh-dark display-2'>Watch!</h1>
									</div>
								</div>
								<div className='row'>
									<div className='col-lg-3 col-sm-3'></div>
									<div className='col-lg-6 col-sm-6'>
										{!isLoading &&
											loadedVideos &&
											loadedVideos.map((video, key) => {
												return (
													<div>
														<h1 style={{ color: 'red' }}>{video.videoTitle}</h1>

														<p
															className='caption'
															style={{
																textAlign: 'center',
																color: 'black',
															}}
														>
															{video.videoCaption}
														</p>
														{
															<YouTube
																style={{ paddingBottom: '3rem' }}
																videoId={ids[key]}
															/>
														}
													</div>
												)
											})}
									</div>
									<div className='col-lg-3 col-sm-3'></div>
								</div>
							</div>
						</div>

						{/* //
				//
				//
				// */}
						<div className='section p-5 container-gray'></div>
					</div>
				)}
				<Footer />
			</React.Fragment>
		</div>
	)
}

export default Home
